const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnQuitHover(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 3",
    transform: "translate(7.999 9)",
    style: {
      stroke: "#4495ff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "m0 0 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 3",
    transform: "rotate(90 6.279 15.279)",
    style: {
      stroke: "#4495ff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "m0 0 13.56 13.559"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnQuitHover);
export default __webpack_public_path__ + "static/media/btn-quit-hover.feefda6ee980572baff1ee8509f757b2.svg";
export { ForwardRef as ReactComponent };